var setPrototypeOf = require("./setPrototypeOf");

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  setPrototypeOf(subClass, superClass);
}

module.exports = _inheritsLoose;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime/helpers/inheritsLoose.js
// module id = 904
// module chunks = 25